/**
 * Shared AI Scanner constants.
 *
 * Values used by more than one AI Scanner view, kept here so the two cannot
 * drift apart.
 */

/**
 * Rendered in place of a match count that is not available yet — a required
 * scan is still loading, or errored with nothing cached. Shown by both the
 * hashtag sheet's submit button and the questions step's header message, which
 * must agree: the member sees the same count in both places.
 */
export const COUNT_PLACEHOLDER = '-';
